import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { message } from "antd";
import useBranding from "../../../hooks/useBranding";
import { portalAuth } from "../../../utils/portalAuth";
import TokenUndefined from "../../Service/TokenUndefined";
import whiteLogo from "../../../assets/boj-images/white_boj_icon.png";
import darkLogo from "../../../assets/boj-images/dark_boj.png";
import banner from "../../../assets/boj-images/boj_banner.jpeg";
import {
  FaTachometerAlt,
  FaUserTie,
  FaUserFriends,
  FaIdBadge,
  FaShoppingBag,
  FaStore,
  FaHotel,
  FaSignOutAlt,
  FaChevronDown,
  FaBars,
  FaTimes,
} from "react-icons/fa";

function ExhibitorDashboardNavbar() {
  const { coverPicUrl, logoUrl } = useBranding();
  const navigate = useNavigate();
  const location = useLocation();

  const [mobileShow, setMobileShow] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [exhibitorName, setExhibitorName] = useState("");
  const [showHotelDetails, setShowHotelDetails] = useState(false);
  const [limitCheck, setLimitCheck] = useState({
    owner: false,
    staff: false,
    extra: false,
  });

  const exhibitorAgentType = (localStorage.getItem("exhibitor_agent_type") || "Exhibitor").toLowerCase();
  const closeTimeoutRef = useRef(null);

  const handleMouseEnter = (key) => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setActiveDropdown(key);
  };

  const handleMouseLeave = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
    closeTimeoutRef.current = setTimeout(() => {
      setActiveDropdown(null);
    }, 200);
  };

  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  const handleDropdownToggle = (key) => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setActiveDropdown((prev) => (prev === key ? null : key));
  };

  const closeDropdownImmediate = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setActiveDropdown(null);
    setMobileShow(false);
  };

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    portalAuth.logoutActive();
    localStorage.removeItem("exhibitor_agent_type");
    navigate(`/${exhibitorAgentType}/login`);
  };

  useEffect(() => {
    TokenUndefined(`${exhibitorAgentType}/login`);
    axios
      .post(`${process.env.REACT_APP_API_END_POINT}/get-exhibitor-name`, "", {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        setExhibitorName(res.data.data);
        setShowHotelDetails(!!res.data.ownersCount);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          navigate(`/${exhibitorAgentType}/login`);
          portalAuth.logoutActive();
        }
      });
  }, [exhibitorAgentType, navigate]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`, {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        setLimitCheck({
          owner: res.data.ownerstatus,
          staff: res.data.staffstatus,
          extra: res.data.extraStatus,
        });
      })
      .catch((err) => console.log(err));
  }, []);

  const handleAddOwnerClick = () => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`, {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        if (res.data.ownerstatus) {
          navigate(`/${exhibitorAgentType}/${exhibitorAgentType}-owner-registration`);
        } else {
          message.error("The Extra member registration limit exceeded");
        }
      });
  };

  const handleExtraBadge = () => {
    if (limitCheck.extra) {
      navigate(`/${exhibitorAgentType}/extra-badges`);
    } else {
      message.error("Adding Extra badge limit has been exhausted");
    }
  };

  const handleAddStaffClick = () => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`, {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        if (res.data.staffstatus) {
          navigate(`/${exhibitorAgentType}/${exhibitorAgentType}-staff-registration`);
        } else {
          message.error("The limit to add new members has exhausted");
        }
      });
  };

  const handleAddViprClick = () => {
    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/form-status-exhibitor`, {
        headers: {
          token: localStorage.getItem("jff_token"),
        },
      })
      .then((res) => {
        if (res.data.vipstatus) {
          navigate(`/${exhibitorAgentType}/${exhibitorAgentType}-vip-registration`);
        } else {
          message.error("The limit to add new members has exhausted");
        }
      });
  };

  const handleAddHotelDetailsClick = () => {
    navigate(`/${exhibitorAgentType}/${exhibitorAgentType}-hotel-details`);
  };

  const handleTravelDetailsClick = () => {
    navigate(`/${exhibitorAgentType}/travel-details`);
  };

  return (
    <header className="crm-navbar-container">
      <div className="crm-navbar">
        {/* Top Banner Image Logo & Exhibitor Name */}
        <div
          className="crm-nav-brand"
          onClick={() => navigate(`/${exhibitorAgentType}/dashboard`)}
        >
          <img
            src={coverPicUrl || banner || logoUrl || whiteLogo}
            alt="The BOJ Show"
            className="crm-brand-banner-logo"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = darkLogo;
            }}
          />
          {exhibitorName && (
            <>
              <span className="crm-brand-divider"></span>
              <span className="crm-brand-title" style={{ fontSize: "0.85rem", textTransform: "uppercase" }}>
                {exhibitorName}
              </span>
            </>
          )}
        </div>

        {/* Mobile Menu Button */}
        <button
          className="crm-mobile-toggle"
          onClick={() => setMobileShow(!mobileShow)}
          aria-label="Toggle Navigation"
        >
          {mobileShow ? <FaTimes /> : <FaBars />}
        </button>

        {/* Horizontal Navigation Links */}
        <ul className={`crm-nav-menu ${mobileShow ? "show" : ""}`}>
          {/* Dashboard */}
          <li>
            <button
              className={`crm-nav-button ${isActive(`/${exhibitorAgentType}/dashboard`) ? "active" : ""}`}
              onClick={() => {
                closeDropdownImmediate();
                navigate(`/${exhibitorAgentType}/dashboard`);
              }}
              onMouseEnter={() => {
                if (closeTimeoutRef.current) {
                  clearTimeout(closeTimeoutRef.current);
                  closeTimeoutRef.current = null;
                }
                setActiveDropdown(null);
              }}
            >
              <FaTachometerAlt /> Dashboard
            </button>
          </li>

          {/* Exhibitor Management */}
          <li
            className={`crm-nav-item-dropdown ${activeDropdown === "management" ? "show" : ""}`}
            onMouseEnter={() => handleMouseEnter("management")}
            onMouseLeave={handleMouseLeave}
          >
            <button
              className="crm-nav-button"
              onClick={() => handleDropdownToggle("management")}
            >
              <FaUserTie /> Management <FaChevronDown size={10} />
            </button>
            <div
              className="crm-dropdown-menu"
              onMouseEnter={() => handleMouseEnter("management")}
              onMouseLeave={handleMouseLeave}
            >
              <div
                className="crm-dropdown-item"
                onClick={() => {
                  closeDropdownImmediate();
                  handleAddOwnerClick();
                }}
              >
                Add Management
              </div>
              <div
                className={`crm-dropdown-item ${isActive(`/${exhibitorAgentType}/owner-list`) ? "active" : ""}`}
                onClick={() => {
                  closeDropdownImmediate();
                  navigate(`/${exhibitorAgentType}/owner-list`);
                }}
              >
                Management List
              </div>
            </div>
          </li>

          {/* Exhibitor Assistant */}
          <li
            className={`crm-nav-item-dropdown ${activeDropdown === "assistant" ? "show" : ""}`}
            onMouseEnter={() => handleMouseEnter("assistant")}
            onMouseLeave={handleMouseLeave}
          >
            <button
              className="crm-nav-button"
              onClick={() => handleDropdownToggle("assistant")}
            >
              <FaUserFriends /> Assistant <FaChevronDown size={10} />
            </button>
            <div
              className="crm-dropdown-menu"
              onMouseEnter={() => handleMouseEnter("assistant")}
              onMouseLeave={handleMouseLeave}
            >
              <div
                className="crm-dropdown-item"
                onClick={() => {
                  closeDropdownImmediate();
                  handleAddStaffClick();
                }}
              >
                Add Assistant
              </div>
              <div
                className={`crm-dropdown-item ${isActive(`/${exhibitorAgentType}/staff-list`) ? "active" : ""}`}
                onClick={() => {
                  closeDropdownImmediate();
                  navigate(`/${exhibitorAgentType}/staff-list`);
                }}
              >
                Assistant List
              </div>
            </div>
          </li>

          {/* Extra Badges */}
          {(!limitCheck.owner || !limitCheck.staff) && (
            <li>
              <button
                className={`crm-nav-button ${isActive(`/${exhibitorAgentType}/extra-badges`) ? "active" : ""}`}
                onClick={() => {
                  closeDropdownImmediate();
                  handleExtraBadge();
                }}
                onMouseEnter={() => {
                  if (closeTimeoutRef.current) {
                    clearTimeout(closeTimeoutRef.current);
                    closeTimeoutRef.current = null;
                  }
                  setActiveDropdown(null);
                }}
              >
                <FaIdBadge /> Extra Badges
              </button>
            </li>
          )}

          {/* Buyer */}
          {exhibitorAgentType === "exhibitor" && (
            <li
              className={`crm-nav-item-dropdown ${activeDropdown === "buyer" ? "show" : ""}`}
              onMouseEnter={() => handleMouseEnter("buyer")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                className="crm-nav-button"
                onClick={() => handleDropdownToggle("buyer")}
              >
                <FaShoppingBag /> Buyer <FaChevronDown size={10} />
              </button>
              <div
                className="crm-dropdown-menu"
                onMouseEnter={() => handleMouseEnter("buyer")}
                onMouseLeave={handleMouseLeave}
              >
                <div
                  className="crm-dropdown-item"
                  onClick={() => {
                    closeDropdownImmediate();
                    handleAddViprClick();
                  }}
                >
                  Add Buyer
                </div>
                <div
                  className={`crm-dropdown-item ${isActive(`/${exhibitorAgentType}/vip-guest-requrest-list`) ? "active" : ""}`}
                  onClick={() => {
                    closeDropdownImmediate();
                    navigate(`/${exhibitorAgentType}/vip-guest-requrest-list`);
                  }}
                >
                  Buyer Request List
                </div>
                <div
                  className={`crm-dropdown-item ${isActive(`/${exhibitorAgentType}/vip-guest-list`) ? "active" : ""}`}
                  onClick={() => {
                    closeDropdownImmediate();
                    navigate(`/${exhibitorAgentType}/vip-guest-list`);
                  }}
                >
                  Buyer Approved List
                </div>
              </div>
            </li>
          )}

          {/* Stall Layout */}
          {exhibitorAgentType === "exhibitor" && (
            <li
              className={`crm-nav-item-dropdown ${activeDropdown === "stall" ? "show" : ""}`}
              onMouseEnter={() => handleMouseEnter("stall")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                className="crm-nav-button"
                onClick={() => handleDropdownToggle("stall")}
              >
                <FaStore /> Stall Layout <FaChevronDown size={10} />
              </button>
              <div
                className="crm-dropdown-menu"
                onMouseEnter={() => handleMouseEnter("stall")}
                onMouseLeave={handleMouseLeave}
              >
                <div
                  className={`crm-dropdown-item ${isActive(`/${exhibitorAgentType}/company-details`) ? "active" : ""}`}
                  onClick={() => {
                    closeDropdownImmediate();
                    navigate(`/${exhibitorAgentType}/company-details`);
                  }}
                >
                  Company Details
                </div>
                <div
                  className={`crm-dropdown-item ${isActive(`/${exhibitorAgentType}/upload-image`) ? "active" : ""}`}
                  onClick={() => {
                    closeDropdownImmediate();
                    navigate(`/${exhibitorAgentType}/upload-image`);
                  }}
                >
                  Select Stall Layout
                </div>
                <div
                  className={`crm-dropdown-item ${isActive(`/${exhibitorAgentType}/furniture-requirments`) ? "active" : ""}`}
                  onClick={() => {
                    closeDropdownImmediate();
                    navigate(`/${exhibitorAgentType}/furniture-requirments`);
                  }}
                >
                  Furniture Requirement
                </div>
                <div
                  className={`crm-dropdown-item ${isActive(`/${exhibitorAgentType}/undertaking-form`) ? "active" : ""}`}
                  onClick={() => {
                    closeDropdownImmediate();
                    navigate(`/${exhibitorAgentType}/undertaking-form`);
                  }}
                >
                  Undertaking Form
                </div>
              </div>
            </li>
          )}

          {/* Hospitality */}
          {exhibitorAgentType === "exhibitor" && (
            <li
              className={`crm-nav-item-dropdown ${activeDropdown === "hospitality" ? "show" : ""}`}
              onMouseEnter={() => handleMouseEnter("hospitality")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                className="crm-nav-button"
                onClick={() => handleDropdownToggle("hospitality")}
              >
                <FaHotel /> Hospitality <FaChevronDown size={10} />
              </button>
              <div
                className="crm-dropdown-menu"
                onMouseEnter={() => handleMouseEnter("hospitality")}
                onMouseLeave={handleMouseLeave}
              >
                <div
                  className={`crm-dropdown-item ${isActive(`/${exhibitorAgentType}/${exhibitorAgentType}-hotel-details`) ? "active" : ""}`}
                  onClick={() => {
                    closeDropdownImmediate();
                    handleAddHotelDetailsClick();
                  }}
                >
                  Add Hotel Details
                </div>
                <div
                  className={`crm-dropdown-item ${isActive(`/${exhibitorAgentType}/travel-details`) ? "active" : ""}`}
                  onClick={() => {
                    closeDropdownImmediate();
                    handleTravelDetailsClick();
                  }}
                >
                  Travel Details
                </div>
              </div>
            </li>
          )}
        </ul>

        {/* Actions (Logout Button) */}
        <div className="crm-nav-actions">
          <button className="crm-logout-btn" onClick={handleLogout} title="Logout">
            <FaSignOutAlt />
          </button>
        </div>
      </div>
    </header>
  );
}

export default ExhibitorDashboardNavbar;
